// extracted by mini-css-extract-plugin
export default {"parent":"Volunteer_parent__4KUza","carouselOuterContainer":"Volunteer_carouselOuterContainer__H39uJ","carouselInnerContainer":"Volunteer_carouselInnerContainer__JXmln"};